/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics
 */
export interface FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics {
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics
     */
    Elapsed: number;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics
     */
    RowsRead?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics
     */
    BytesRead?: number | null;
}

/**
 * Check if a given object implements the FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics interface.
 */
export function instanceOfFxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics(value: object): value is FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics {
    if (!('Elapsed' in value) || value['Elapsed'] === undefined) return false;
    return true;
}

export function FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsFromJSON(json: any): FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics {
    return FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsFromJSONTyped(json, false);
}

export function FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'Elapsed': json['Elapsed'],
        'RowsRead': json['RowsRead'] == null ? undefined : json['RowsRead'],
        'BytesRead': json['BytesRead'] == null ? undefined : json['BytesRead'],
    };
}

export function FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsToJSON(json: any): FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics {
    return FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsToJSONTyped(json, false);
}

export function FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsToJSONTyped(value?: FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Elapsed': value['Elapsed'],
        'RowsRead': value['RowsRead'],
        'BytesRead': value['BytesRead'],
    };
}

